import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlSegment } from '@angular/router';
import { SessionInitService } from '@services/session-init.service';
import { UserStateService } from '@services/user-state.service';

export const AuthGuard: CanMatchFn = (_, segments: UrlSegment[]) => {
  const userStateService = inject(UserStateService);
  const router = inject(Router);
  const sessionInitService = inject(SessionInitService);

  const token = userStateService.getToken();

  if (token) {
    // Initialize session timeout when accessing protected routes
    sessionInitService.initializeSessionIfLoggedIn();
    return true;
  }

  // Preserve the attempted deep link so login can redirect back to it
  // (FS-16) instead of always dropping to the dashboard.
  const attemptedUrl = '/' + segments.map((segment) => segment.path).join('/');
  router.navigate(['/auth/login'], {
    queryParams: { returnUrl: attemptedUrl }
  });
  return false;
};
